import React from "react";

interface IFooterProps {
  className?: string;
  bannerColor?: "white" | "black";
}

const infillionWhiteBanner = require("../assets/infillion-banner.png");
const infillionBlackBanner = require("../assets/infillion-black-banner.png");

const Footer = ({ className, bannerColor }: IFooterProps) => {
  return (
    <>
      <div className={`footer-container ${className}`}>
        <span className="powered-by-text">Powered by</span>
        <img
          className="infillion-banner"
          src={
            bannerColor && bannerColor === "white"
              ? infillionWhiteBanner
              : infillionBlackBanner
          }
        ></img>
      </div>
    </>
  );
};

export default Footer;
